var homePageScript = function() {

    jQuery(document).scroll(function (e) {
        var y = $(this).scrollTop();
        if (y > 56) {
            $('.home-header').addClass('headerBg');
        } else {
            $('.home-header').removeClass('headerBg');
        }
        if (y > 170) {
            $('.logo').css("opacity", "0.8");
        } else {
            $('.logo').css("opacity", "0");
        }

    });

    $(".angleDown i").click(function() {
        $('html, body').animate({
            scrollTop: $("#first-section").offset().top
        }, 500);
    });

};

function toggleMobileMenu() {
    if ($('.header-mobile-options').css("display") === 'none') {
        return $('.header-mobile-options').css({'height': '60px', display: 'flex'});
    }
    $('.header-mobile-options').css({'height': '0px', display: 'none'});
}

function initPageWithViewModel(vm) {
    ko.applyBindings(vm);
}

function clientSideRedirectRoutes() {

    //TODO: make sure we don't need client routes for static pages.

    Sammy(function() {
        this.get('#(.*)', function() {
		    var hostEtc = window.location.href.replace(window.location.hash, '');
		    hostEtc = hostEtc + "?isApp=true" + window.location.hash;
		    location.replace(hostEtc);
		});
    }).run();

}





